export default {
  query: {
    url: '/wxcardbag/page',
    method: 'post',
  },
  // 是否启用会员卡模板
  updateIsDelete: {
    url: '/wxcardbag/updateIsDelete',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  // 将会员卡发布至微信
  publish: {
    url: '/wxcardbag/publish',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  // 保存或更新会员卡
  save: {
    url: '/wxcardbag',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  // 查询已经发布的图片
  // params  logo, background
  getUploadImageUrl: {
    url: '/wxcardbag/getUploadImageUrl',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  source:{
    url:'/source',
  }
}



// WEBPACK FOOTER //
// ./src/pages/wechat/memberCard/api/index.js